// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__217By","title":"styles_title__2txXy"};